/**
 * Instância Axios para as APIs protegidas (admin / facilitador / importar).
 * Lê o session-token do better-auth armazenado no sessionStorage
 * (salvo pelo authClient após signIn bem-sucedido).
 */
import axios from 'axios'

const adminAxios = axios.create()

adminAxios.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('baToken')
  if (token) {
    if (config.headers && typeof (config.headers as any).set === 'function') {
      (config.headers as any).set('Authorization', `Bearer ${token}`)
    } else {
      config.headers = config.headers || ({} as any)
      ;(config.headers as any)['Authorization'] = `Bearer ${token}`
    }
  }
  return config
})

export default adminAxios
